var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import React from "react";
const TextColorIcon = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    width: "12px",
    height: "15px",
    viewBox: "0 0 12 15",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props),
  /* @__PURE__ */ React.createElement("g", { id: "Specs-for-devs", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React.createElement("g", { id: "Icons", transform: "translate(-178.000000, -127.000000)", fill: "#000000" }, /* @__PURE__ */ React.createElement(
    "g",
    {
      id: "Icons-/-Formatting-/-Text-color-/-All-Copy-11",
      transform: "translate(178.000000, 127.000000)"
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M3.8398,6 L5.8398,1 L6.1598,1 L8.1598,6 L3.8398,6 Z M9.7598,10 L10.8398,10 L6.8398,0 L5.1598,0 L1.1598,10 L2.2398,10 L3.4408,7 L8.5598,7 L9.7598,10 Z",
        id: "Fill-2"
      }
    ),
    /* @__PURE__ */ React.createElement("polygon", { fill: "currentColor", id: "Fill-3", points: "0 15 12 15 12 12 0 12" })
  )))
);
var TextColorIcon_default = TextColorIcon;
export {
  TextColorIcon_default as default
};
//# sourceMappingURL=TextColorIcon.js.map
